import "./styles/globals.css";
import "./styles/variables.css";
import "./App.css";
import Header from "./components/header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import DetroitDivest from "./pages/DetroitDivest";
import Join from "./pages/Join";
import { Zines } from "./pages/Zines";
import Footer from "./components/footer";
import ScrollToTop from "./components/ScrollToTop";
import DocumentTitle from "./components/DocumentTitle";

function App() {
  return (
    <div className="App">
      {/* <StyleViewer /> */}
      <BrowserRouter>
        <ScrollToTop />
        <DocumentTitle />
        {/* Bypass blocks (WCAG 2.4.1): the header and nav repeat on every page,
            so keyboard users need a way past them. */}
        <a className="skip-link" href="#main-content">
          Skip to content
        </a>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/detroit-divest" element={<DetroitDivest />} />
          <Route path="/zines" element={<Zines />} />
          <Route path="/join-us" element={<Join />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
